var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('div',[_c('span',{staticClass:"tag",class:_vm.shipmentStatuses[_vm.status].class},[_vm._v(" "+_vm._s(_vm.shipmentStatuses[_vm.status].label)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }